;(function () {
  // for IE (polyfill)
  if (typeof window.CustomEvent === 'function') return false
  function CustomEvent(event, params) {
    params = params || { bubbles: false, cancelable: false, detail: null }
    var evt = document.createEvent('CustomEvent')
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail)
    return evt
  }
  window.CustomEvent = CustomEvent
})()

export default class Analytics {
  constructor() {
    this.sendAnalyticsPageview = this.sendAnalyticsPageview.bind(this)
    this.sendAnalyticsEvent = this.sendAnalyticsEvent.bind(this)
    this.sendCustomEvent = this.sendCustomEvent.bind(this)
    this.checkForAnalytics = this.checkForAnalytics.bind(this)
  }

  sendCustomEvent(eventName, eventDetail) {
    let activityEvent = new CustomEvent(eventName, { detail: eventDetail })
    document.body.dispatchEvent(activityEvent)
  }

  /* the second argument will be used to update the data layer, still working out the details for this, 
  ideally team would pass the values they expect and in this function before sending the event we will update the data layer for each team. 
  This will send a page view event for analytics, only use if instructed to do so by the analytics team. */
  sendAnalyticsPageview(TYPE) {
    this.checkForAnalytics(window, 1, TYPE)
  }

  /*s and _satellite are Adobe analytics objects, if they are ready to listen send the event*/
  checkForAnalytics(OBJ, ATTEMPTS, TYPE) {
    if (OBJ.s && OBJ._satellite) {
      this.sendCustomEvent(TYPE)
    } else if (ATTEMPTS < 6) {
      /*run 5 times, then stop checking*/
      ATTEMPTS++
      setTimeout(() => {
        this.checkForAnalytics(window, ATTEMPTS, TYPE)
      }, 3000)
    }
  }

  /* expecting to see a message object with specific key value pairs, this will set and send analytics variables for events
  do not allow the event to run without a message object to prevent unnecessary calls*/
  sendAnalyticsEvent(TYPE, MESSAGE_OBJECT) {
    try {
      if (typeof MESSAGE_OBJECT === 'object' && MESSAGE_OBJECT !== null) {
        this.sendCustomEvent(TYPE, MESSAGE_OBJECT)
      }
    } catch (err) {
      //log err? discuss
    }
  }
}

// methods to be consumed by outside world
const { sendAnalyticsPageview, sendAnalyticsEvent } = new Analytics()
export { sendAnalyticsPageview, sendAnalyticsEvent }
